// Func = limiting Scope for this file
var lastScrollTop = 0;

let logo;

gsap.registerPlugin(ScrollTrigger);

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


function getAccommodationByTag( tag, holder, module, item_title_style, item_subtitle_style ){
	const FORM_DATA = new FormData();

	FORM_DATA.append('operation', 'getAccommodationByTag');
	FORM_DATA.append('tag', tag);
	FORM_DATA.append('item_title_style', item_title_style);
	FORM_DATA.append('item_subtitle_style', item_subtitle_style);

	fetch(`${site_url}/ajax/functions.php`, { 
		method: 'POST',
		body: FORM_DATA 
	})
	.then((response) => response.json())
	.then((data) => {
		if( data.err == true ){
			console.error(`Something went wrong with the module ${module.id};\n ${err_msg}`);
		}else{
			holder.innerHTML = data.html;
			initAllSwipers();
		}
	})
	.catch((error) => {
		console.error(`Something went wrong with the module ${module.id};\n ${error}`);
	});
}

function manageAccommodationModule(){
	const ALL_ACCOMMODATIONS_MODULE = document.querySelectorAll(`.js-accommodations`);

	ALL_ACCOMMODATIONS_MODULE.forEach( module => {
		let filter = module.querySelector('.js-accommodations_filter'),
			holder = module.querySelector('.js-accommodations_holder'),
			selectorOnMobile = module.querySelector('.js-accommodations_selector'),
			beforeOptionActive = null;

		if( !filter || !holder ) return;

		filter.addEventListener( 'click', event => {
			let elementClicked = event.target;
			if( elementClicked.nodeName == 'LI' ){
				if( beforeOptionActive )
					beforeOptionActive.classList.remove('active');

				getAccommodationByTag( elementClicked.dataset.tag, holder, module, holder.dataset.item_title_style, holder.dataset.item_subtitle_style );

				elementClicked.classList.add('active');
				beforeOptionActive = elementClicked;

				if( window.innerWidth < 641 && selectorOnMobile ){
					selectorOnMobile.classList.remove("active")
					selectorOnMobile.textContent = elementClicked.textContent;
				}
			}
		} );

		filter.querySelector('li').click();

		if( window.innerWidth < 641 && selectorOnMobile ){
			selectorOnMobile.addEventListener("click", () => {
				selectorOnMobile.classList.toggle("active");
			})
		}
	} );
}
function getDinginMenu( menu_id, holder, module ){
	const FORM_DATA = new FormData();

	FORM_DATA.append('operation', 'getDinginMenu');
	FORM_DATA.append('menu_id', menu_id);

	fetch(`${site_url}/ajax/functions.php`, { 
		method: 'POST',
		body: FORM_DATA 
	})
	.then((response) => response.json())
	.then((data) => {
		if( data.err == true ){
			console.error(`Something went wrong with the module ${module.id};\n ${data.err_msg}`);
		}else{
			holder.innerHTML = data.html;
		}
	})
	.catch((error) => {
		console.error(`Something went wrong with the module ${module.id};\n ${error}`);
	});
}

function manageDiningMenusModule(){
	const ALL_MENUS_MODULE = document.querySelectorAll(`.js-menusQuad`);

	ALL_MENUS_MODULE.forEach( module => {
		let filter = module.querySelector('.js-menusQuad_filter'),
			holder = module.querySelector('.js-menusQuad_holder'),
			selectorOnMobile = module.querySelector('.js-menusQuad_selector'),
			beforeOptionActive = null;

		filter.addEventListener( 'click', event => {
			let elementClicked = event.target;
			if( elementClicked.nodeName == 'LI' ){
				if( beforeOptionActive )
					beforeOptionActive.classList.remove('active');

				getDinginMenu( elementClicked.dataset.menu, holder, module );

				elementClicked.classList.add('active');
				beforeOptionActive = elementClicked;

				if( window.innerWidth < 641 ){
					selectorOnMobile.classList.remove("active")
					selectorOnMobile.textContent = elementClicked.textContent;
				}
			}
		} );

		filter.querySelector('li').click();

		if( window.innerWidth < 641 ){
			selectorOnMobile.addEventListener("click", () => {
				selectorOnMobile.classList.toggle("active");
			})
		}
	} );
}

function manageDiningMenusIAModule() {
    const modules = document.querySelectorAll('.js-menusQuadIA');

    modules.forEach(module => {
        const tabList = module.querySelector('[role="tablist"]');
        if (!tabList) return;

        const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
        if (tabs.length === 0) return;

        const panels = tabs.map(tab => {
            const targetId = tab.getAttribute('aria-controls');
            return targetId ? module.querySelector(`#${targetId}`) : null;
        });

        const isMobileScreen = window.innerWidth <= 768;

        if (isMobileScreen) {
            tabList.style.display = 'none';

            let mobileSelect = module.querySelector('.js-menusQuad_mobileSelect');
            if (!mobileSelect) {
                mobileSelect = document.createElement('select');
				mobileSelect.name = 'menusQuadIASelect';				
                mobileSelect.className = 'menusQuadIA_select js-menusQuad_mobileSelect';
                mobileSelect.setAttribute('aria-label', 'Select Menu');

                tabs.forEach((tab, index) => {
                    const option = document.createElement('option');
                    option.value = index;
                    option.textContent = tab.textContent.trim();
                    if (tab.getAttribute('aria-selected') === 'true' || tab.classList.contains('is-active')) {
                        option.selected = true;
                    }
                    mobileSelect.appendChild(option);
                });

                tabList.parentNode.insertBefore(mobileSelect, tabList);
            }

            function activateMobileTab(index) {
                panels.forEach((panel, i) => {
                    if (!panel) return;
                    if (i === index) {
                        panel.removeAttribute('hidden');
                        panel.style.display = 'block';
                    } else {
                        panel.setAttribute('hidden', '');
                        panel.style.display = 'none';
                    }
                });
            }

            mobileSelect.addEventListener('change', (e) => {
                activateMobileTab(parseInt(e.target.value, 10));
            });

            const initialIndex = mobileSelect.selectedIndex >= 0 ? mobileSelect.selectedIndex : 0;
            activateMobileTab(initialIndex);

        } else {
            function activateTab(index) {
                tabs.forEach((tab, i) => {
                    const isActive = i === index;
                    tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                    tab.setAttribute('tabindex', isActive ? '0' : '-1');
                    tab.classList.toggle('is-active', isActive);
                });

                panels.forEach((panel, i) => {
                    if (!panel) return;
                    if (i === index) {
                        panel.removeAttribute('hidden');
                        panel.style.display = 'block';
                    } else {
                        panel.setAttribute('hidden', '');
                        panel.style.display = 'none';
                    }
                });
            }

            tabs.forEach((tab, index) => {
                tab.addEventListener('click', () => activateTab(index));

                tab.addEventListener('keydown', (e) => {
                    let newIndex = index;
                    switch (e.key) {
                        case 'ArrowRight':
                            newIndex = (index + 1) % tabs.length;
                            break;
                        case 'ArrowLeft':
                            newIndex = (index - 1 + tabs.length) % tabs.length;
                            break;
                        case 'Home':
                            newIndex = 0;
                            break;
                        case 'End':
                            newIndex = tabs.length - 1;
                            break;
                        default:
                            return;
                    }
                    e.preventDefault();
                    activateTab(newIndex);
                    tabs[newIndex].focus();
                });
            });

            const initialActiveIndex = tabs.findIndex(tab => 
                tab.getAttribute('aria-selected') === 'true' || tab.classList.contains('is-active')
            );
            activateTab(initialActiveIndex !== -1 ? initialActiveIndex : 0);
        }
    });
}

function getVenues( venue_location, venue_type, holder, module, globalCtaLink, globalCtaLabel, item_title_style, item_subtitle_style ){
	const FORM_DATA = new FormData();

	FORM_DATA.append('operation', 'getVenues');
	FORM_DATA.append('venue_location', venue_location);
	FORM_DATA.append('venue_type', venue_type);
	FORM_DATA.append('globalCtaLink', globalCtaLink);
	FORM_DATA.append('globalCtaLabel', globalCtaLabel);
	FORM_DATA.append('item_title_style', item_title_style);
	FORM_DATA.append('item_subtitle_style', item_subtitle_style);

	fetch(`${site_url}/ajax/functions.php`, { 
		method: 'POST',
		body: FORM_DATA 
	})
	.then((response) => response.json())
	.then((data) => {
		if( data.err == true ){
			console.error(`Something went wrong with the module ${module.id};\n ${data.err_msg}`);
		}else{
			holder.innerHTML = data.html;
		}
	})
	.catch((error) => {
		console.error(`Something went wrong with the module ${module.id};\n ${error}`);
	});
}

function manageVenuesModule(){
	const ALL_MENUS_MODULE = document.querySelectorAll(`.js-venues`);

	ALL_MENUS_MODULE.forEach( module => {
		let filter = module.querySelector('.js-venues_filter'),
			holder = module.querySelector('.js-venues_holder'),
			selectorOnMobile = module.querySelector('.js-venues_selector'),
			beforeOptionActive = null,
			globalCtaLink = holder.dataset.globalctalink,
			globalCtaLabel = holder.dataset.globalctalabel;
			item_title_style = holder.dataset.item_title_style;
			item_subtitle_style = holder.dataset.item_subtitle_style;

		filter.addEventListener( 'click', event => {
			let elementClicked = event.target;
			if( elementClicked.nodeName == 'LI' ){
				if( beforeOptionActive )
					beforeOptionActive.classList.remove('active');

				getVenues( elementClicked.dataset.venue_location, elementClicked.dataset.venue_type, holder, module, globalCtaLink, globalCtaLabel, item_title_style, item_subtitle_style );

				elementClicked.classList.add('active');
				beforeOptionActive = elementClicked;

				if( window.innerWidth < 641 ){
					selectorOnMobile.classList.remove("active")
					selectorOnMobile.textContent = elementClicked.textContent;
				}
			}
		} );

		filter.querySelector('li').click();

		if( window.innerWidth < 641 ){
			selectorOnMobile.addEventListener("click", () => {
				selectorOnMobile.classList.toggle("active");
			})
		}
	} );
}

function getOffers( tag, holder, module, item_title_style, item_subtitle_style ){
	const FORM_DATA = new FormData();

	FORM_DATA.append('operation', 'getOffers');
	FORM_DATA.append('tag', tag);
	FORM_DATA.append('item_title_style', item_title_style);
	FORM_DATA.append('item_subtitle_style', item_subtitle_style);

	fetch(`${site_url}/ajax/functions.php`, { 
		method: 'POST',
		body: FORM_DATA 
	})
	.then((response) => response.json())
	.then((data) => {
		if( data.err == true ){
			console.error(`Something went wrong with the module ${module.id};\n ${data.err_msg}`);
		}else{
			holder.innerHTML = data.html;
		}
	})
	.catch((error) => {
		console.log(error);
		console.error(`Something went wrong with the module ${module.id};\n ${error}`);
	});
}

function manageOffersModule(){
	const ALL_OFFERS_MODULE = document.querySelectorAll(`.js-offers`);

	ALL_OFFERS_MODULE.forEach( module => {
		let filter = module.querySelector('.js-offers_filter'),
			holder = module.querySelector('.js-offers_holder'),
			selectorOnMobile = module.querySelector('.js-offers_selector'),
			beforeOptionActive = null;

		filter.addEventListener( 'click', event => {
			let elementClicked = event.target;
			if( elementClicked.nodeName == 'LI' ){
				if( beforeOptionActive )
					beforeOptionActive.classList.remove('active');

				getOffers( elementClicked.dataset.tag, holder, module, holder.dataset.item_title_style, holder.dataset.item_subtitle_style );

				elementClicked.classList.add('active');
				beforeOptionActive = elementClicked;

				if( window.innerWidth < 641 ){
					selectorOnMobile.classList.remove("active")
					selectorOnMobile.textContent = elementClicked.textContent;
				}
			}
		} );

		filter.querySelector('li').click();

		if( window.innerWidth < 641 ){
			selectorOnMobile.addEventListener("click", () => {
				selectorOnMobile.classList.toggle("active");
			})
		}
	} );
}

function getEventsCalendar({ month, category, view, holder, module }){
	const FORM_DATA = new FormData();

	FORM_DATA.append('operation', 'getEventsCalendar');
	FORM_DATA.append('month', month);
	FORM_DATA.append('category', category);
	FORM_DATA.append('view', view);

	fetch(`${site_url}/ajax/functions.php`, { 
		method: 'POST',
		body: FORM_DATA 
	})
	.then((response) => response.json())
	.then((data) => {
		if( data.err == true ){
			console.error(`Something went wrong with the module ${module.id};\n ${data.err_msg}`);
		}else{
			holder.innerHTML = data.html;
		}
	})
	.catch((error) => {
		console.log(error);
		console.error(`Something went wrong with the module ${module.id};\n ${error}`);
	});
}

function manageEventsCalendarModule(){
	const ALL_EVENTS_CALENDAR_MODULE = document.querySelectorAll(`.js-events`);

	const mapOptionsSelected = (filter, state) => {
		if( !filter || !state )
			return {};

		let monthValue = filter.querySelector(".js-events_months span").dataset.value,
			categoryValue = filter.querySelector(".js-events_categories span").dataset.value;

		state.month = monthValue;
		state.category = categoryValue;

		return state;
	}

	ALL_EVENTS_CALENDAR_MODULE.forEach( module => {
		let filter = module.querySelector('.js-events-filter'),
			holder = module.querySelector('.js-events_holder'),
			reset = module.querySelector('.js-events-reset'),
			views = module.querySelector('.js-events_views'),
			beforeViewActive = null;
		const filterState = { 
			month: '',
			category : '',
			view: '',
			holder: holder,
			module: module
		};

		mapOptionsSelected(filter, filterState);

		module.querySelectorAll('.events_select').forEach( select => {
			select.addEventListener("click", (e) => {
				let elementClicked = e.target;

				if( elementClicked.nodeName == "SPAN" ){
					select.classList.toggle("active");
				}

				if( elementClicked.nodeName == "LI" ){
					select.classList.remove("active");
					select.querySelector('span').textContent = elementClicked.textContent;
					select.querySelector('span').dataset.value = elementClicked.dataset.value;
					mapOptionsSelected(filter, filterState);
					getEventsCalendar( filterState );
				}
			})
		} )

		// Use event delegation for dynamically added month trigger buttons
		module.addEventListener("click", (e) => {
			if (e.target.closest('.js-month-trigger')) {
				const button = e.target.closest('.js-month-trigger');
				// Get the month from data-target attribute
				const targetMonth = button.getAttribute('data-target');
				if (targetMonth) {
					filterState.month = targetMonth;
					// Update the month display in the filter
					const monthSelect = filter.querySelector('.js-events_months span');
					if (monthSelect) {
						monthSelect.dataset.value = targetMonth;
						// Parse the new "M Y" format (e.g., "Nov 2025")
						const dateParts = targetMonth.split(' ');
						const monthName = dateParts[0];
						const year = parseInt(dateParts[1]);
						
						// Convert month name to month index
						const monthDate = new Date(`${monthName} 1, ${year}`);
						const fullMonthName = monthDate.toLocaleDateString('en-US', { month: 'long' });
						
						monthSelect.textContent = targetMonth.toUpperCase();
						
						// Update all .events_labelMonth elements in the calendar view
						module.querySelectorAll('.events_labelMonth').forEach(labelElement => {
							labelElement.textContent = fullMonthName.toUpperCase();
						});
						
						// Update data-target attributes for prev/next buttons
						const currentMonthIndex = monthDate.getMonth(); // 0-based month index
						
						// Calculate previous month
						const prevDate = new Date(year, currentMonthIndex - 1, 1);
						const prevMonthName = prevDate.toLocaleDateString('en-US', { month: 'short' });
						const prevYear = prevDate.getFullYear();
						const prevTarget = `${prevMonthName} ${prevYear}`;
						
						// Calculate next month
						const nextDate = new Date(year, currentMonthIndex + 1, 1);
						const nextMonthName = nextDate.toLocaleDateString('en-US', { month: 'short' });
						const nextYear = nextDate.getFullYear();
						const nextTarget = `${nextMonthName} ${nextYear}`;
						
						// Update the data-target attributes
						const prevButton = module.querySelector('.js-month-trigger.prev');
						const nextButton = module.querySelector('.js-month-trigger.next');
						
						if (prevButton) {
							prevButton.setAttribute('data-target', prevTarget);
						}
						if (nextButton) {
							nextButton.setAttribute('data-target', nextTarget);
						}
						mapOptionsSelected(filter, filterState);
						getEventsCalendar( filterState );
					}
					
				}
				
			}
		})

		reset.addEventListener("click", () => {
			module.querySelectorAll('.events_select').forEach( select => {
				select.querySelector('span').textContent = select.querySelector('li').textContent;
				select.querySelector('span').dataset.value = select.querySelector('li').dataset.value;
			});
			mapOptionsSelected(filter, filterState);
			getEventsCalendar( filterState );
		})

		views.addEventListener( 'click', event => {
			let elementClicked = event.target;
			if( elementClicked.nodeName == 'BUTTON' ){
				filterState.view = elementClicked.dataset.view;
				if( beforeViewActive )
					beforeViewActive.classList.remove('active');

				getEventsCalendar( filterState );

				elementClicked.classList.add('active');
				beforeViewActive = elementClicked;
			}
		} );

		views.querySelector('button').click();
	} );
}


function managePrimaryNavFirstTemplate(){
	// Replaced by createAccessibleModal — see DOMContentLoaded block at the bottom of this file
}

function insertSymClassOnForm(){
	const ALL_FORMS = document.querySelectorAll(`.form-module`);

	ALL_FORMS.forEach( form => {
		let allTextHTMLTags = form.querySelectorAll('h1, h2, h3, h4, h5, h6, p'); 
		allTextHTMLTags.forEach( element => {
			if( element.nodeName == 'P' ){
				element.classList.add(`sym-paragraph`)
			}else{
				element.classList.add(`sym-${element.nodeName.toLowerCase()}`)
			}
		} )
	} );
}

function scrollW(){
	let image_logo = logo.querySelector('img');
	let logo_default = image_logo.dataset.default,
		logo_scroll = image_logo.dataset.scroll;

	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		image_logo.src = logo_scroll;
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		image_logo.src = logo_default;
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate-fade');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*1){
			animatedEl[i].classList.add('fade-in');
			animatedEl[i].classList.remove('fade-out');
		} else {
			animatedEl[i].classList.remove('fade-in');
			animatedEl[i].classList.add('fade-out');
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//cms form focus animation
if (document.querySelectorAll('.form-module__field').length > 0) {
	document.querySelectorAll('.form-module__field').forEach(field => {
		if (field.querySelector('input')) {
			field.querySelector('input').addEventListener('focus', () => { field.classList.add('focused') })
		}
		if (field.querySelector('select')) {
			field.querySelector('select').addEventListener('focus', () => { field.classList.add('focused') })
		}
		if (field.querySelector('textarea')) {
			field.querySelector('textarea').addEventListener('focus', () => { field.classList.add('focused') })
		}
	});
}
if (document.querySelectorAll('.field').length > 0) {
	document.querySelectorAll('.field').forEach(field => {
		if (field.querySelector('input')) {
			field.querySelector('input').addEventListener('focus', () => { field.classList.add('focused') })
		}
		if (field.querySelector('select')) {
			field.querySelector('select').addEventListener('focus', () => { field.classList.add('focused') })
		}
		if (field.querySelector('textarea')) {
			field.querySelector('textarea').addEventListener('focus', () => { field.classList.add('focused') })
		}
	});
}

(function(){


	// LENIS
	const lenis = new Lenis({
		duration: 1.6,
		easing: (t) => {
			const c1 = 1.70158;
			const c3 = c1 + 1;
			return c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2) + 1;
		}, // Back ease-out - has a slight overshoot for natural feel
		direction: 'vertical',
		gestureDirection: 'vertical',
		smooth: true,
		mouseMultiplier: 0.9,
		smoothTouch: false,
		touchMultiplier: 2.0,
		infinite: false,
	});

	// Initialize a new Lenis instance for smooth scrolling

	// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
	lenis.on('scroll', ScrollTrigger.update);

	// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
	// This ensures Lenis's smooth scroll animation updates on each GSAP tick
	gsap.ticker.add((time) => {
		lenis.raf(time * 1000); // Convert time from seconds to milliseconds
	});

	// Disable lag smoothing in GSAP to prevent any delay in scroll animations
	gsap.ticker.lagSmoothing(0);
	// END LENIS


	// Parallax animation for elements with data-parallax attribute
	// gsap.utils.toArray('[data-parallax]').forEach(function(element) {
	// 	const parallaxValue = parseFloat(element.getAttribute('data-parallax')) || 0.5;
	// 	const yMovement = 50 * parallaxValue; // Adjust the movement range as needed
		
	// 	gsap.fromTo(element, {
	// 		y: yMovement
	// 	}, {
	// 		y: -yMovement,
	// 		ease: 'none',
	// 		scrollTrigger: {
	// 			trigger: element,
	// 			start: 'top bottom',
	// 			end: 'bottom top',
	// 			scrub:1, // Smooth scrubbing effect
	// 			invalidateOnRefresh: true, // Recalculate on window resize
	// 		}
	// 	});
	// });

    let itemsMenu = document.querySelectorAll('.privary-navigation__list .privary-navigation__item');
	itemsMenu.forEach((itemMenu) => {
		if (itemMenu.querySelector('.submenu')) {
			let timeout;
			const itemsub = itemMenu.querySelector('.submenu');
			const parentText = itemMenu.querySelector(':scope > a').textContent.trim() || '';
			const subItems = itemsub.querySelectorAll('.privary-navigation__item a');

			subItems.forEach((item, index) => {
				if (index === 0 && item.textContent == 'Overview') {
					item.setAttribute(
						'aria-label',
						`Overview of ${parentText}`
					);
				} else {
					item.setAttribute(
						'aria-label',
						item.textContent
					);
				}
			});
			
			itemMenu.addEventListener('mouseenter', () => {
				clearTimeout(timeout);
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave', () => {
				timeout = setTimeout(() => {
					itemMenu.classList.remove('hover');
					itemMenu.querySelector('.submenu').classList.remove('show');
				}, 300); // 2 seconds timeout
			});
		}
	});

    window.onload = function() {	
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	setTimeout(() => {
		if (document.querySelector('#termly-code-snippet-support')) {
			document.querySelector('#termly-code-snippet-support').setAttribute('data-lenis-prevent', '');
		}
	}, 1000);

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	logo = document.querySelector(`.js-scroll-logo`);

	if( document.querySelector(`.principalMenu`) )
		managePrimaryNavFirstTemplate();

	if( document.querySelector(`.js-accommodations`) )
		manageAccommodationModule();

	if( document.querySelector(`.js-menusQuad`) )
		manageDiningMenusModule();

	if( document.querySelector(`.js-menusQuadIA`) )
		manageDiningMenusIAModule();

	if( document.querySelector(`.js-venues`) )
		manageVenuesModule();

	if( document.querySelector(`.js-offers`) )
		manageOffersModule();

	if( document.querySelector(`.js-events`) )
		manageEventsCalendarModule();

	if( document.querySelector(`.form-module`) )
		insertSymClassOnForm();

})();
/*ADA Function*/
function createAccessibleModal({
	container,
	openBtn,
	openBtns,
	closeBtn,
	main,
	onOpen,
	onClose
}) {
	// Support both a single openBtn and multiple openBtns
	const triggerBtns = openBtns
		? Array.from(openBtns)
		: openBtn
		? [openBtn]
		: [];

	if (!container || !triggerBtns.length) return;

	const firstTrigger = triggerBtns[0];

	const getFocusables = () =>
		container.querySelectorAll(
			'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
		);

	function trapFocus(e) {
		const focusables = getFocusables();
		if (!focusables.length) return;

		const first = focusables[0];
		const last = focusables[focusables.length - 1];

		if (e.key === 'Escape') close();

		if (e.key === 'Tab') {
			if (e.shiftKey && document.activeElement === first) {
				e.preventDefault();
				last.focus();
			} else if (!e.shiftKey && document.activeElement === last) {
				e.preventDefault();
				first.focus();
			}
		}
	}

	function open() {
		container.classList.add('open');
		container.inert = false;
		container.setAttribute('aria-hidden', 'false');

		if (main) main.inert = true;

		const first = getFocusables()[0];
		if (first) first.focus();

		container.addEventListener('keydown', trapFocus);
		onOpen && onOpen();
	}

	function close() {
		container.classList.remove('open');
		container.inert = true;
		container.setAttribute('aria-hidden', 'true');

		if (main) main.inert = false;

		container.removeEventListener('keydown', trapFocus);
		firstTrigger.focus();

		onClose && onClose();
	}

	// Set initial state
	container.classList.remove('open');
	container.inert = true;
	container.setAttribute('aria-hidden', 'true');

	triggerBtns.forEach(btn => btn.addEventListener('click', open));
	if (closeBtn) closeBtn.addEventListener('click', close);
}

document.addEventListener('DOMContentLoaded', function(){
	createAccessibleModal({
		container: document.querySelector('.js-principalMenu'),
		openBtns: document.querySelectorAll('.js-principalMenu_open'),
		closeBtn: document.querySelector('.js-principalMenu_close'),
		main: document.querySelector('main')
	});

	const primaryNav = document.getElementById('primary-nav');
	if (primaryNav) {
		primaryNav.querySelectorAll('.privary-navigation__item .submenu').forEach(function (ele) {
			ele.querySelectorAll("a").forEach((e) => {
				e.setAttribute("tabindex", "0");
			});
		});
	}
});
/*End ADA Function*/